import EventEmitter from 'promise-events';
export const PlaybackEventEmitter = new EventEmitter();
//# sourceMappingURL=PlaybackEventEmitter.js.map